module.exports = __webpack_public_path__ + "img/rosepetal-dep-cerealto-vb.cf86c5a1.jpg";